import type { PropsWithChildren } from 'react'
import React from 'react'
import { clsx } from 'clsx'
import styles from './Typography.module.scss'

export const color = ['grey', 'red', 'white', 'green', 'darkgrey', 'blue'] as const
export const variants = ['default', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'] as const
export const weight = ['normal', 'bold'] as const

export type TypographyColor = (typeof color)[number]
export type TypographyVariants = (typeof variants)[number]
export type TypographyWeight = (typeof weight)[number]

export type TypographyProps = PropsWithChildren<{
  as?: keyof React.JSX.IntrinsicElements
  variant?: TypographyVariants
  className?: string
  weight?: TypographyWeight
  color?: TypographyColor
  onClick?: () => void
}>

const Typography = ({
  children,
  as: DynamicTag = 'p',
  variant = 'default',
  weight = 'normal',
  color,
  onClick,
  className,
}: TypographyProps) => (
  <DynamicTag
    onClick={onClick}
    className={clsx(
      styles[`text-${variant}`],
      styles[`weight-${weight}`],
      styles[`color-${color}`],
      styles[`${className}`],
      className,
    )}
  >
    {children}
  </DynamicTag>
)

export default Typography
